import React, { Component } from "react";
import TextArea from '../../reusable/components/TextArea';
import Button from "../../reusable/components/Button.jsx";
import { Modal } from '@deere/ux.uxframe-react';

class CommentComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCmtModal: false,
            errorMessage: "",
            commentVal: "",
        };
        this.handleInput = this.handleInput.bind(this);
        this.handleComment = this.handleComment.bind(this);
    }

    handleInput = (e) => {
        let value = e.target.value;
        this.setState({ commentVal: value });
    }

    handleComment = () => {
        let cmts = this.state.commentVal;
        if (cmts === undefined || cmts == null || cmts === "") {
            this.setState({ errorMessage: "Please enter comments" });
        } else {
            this.setState({ errorMessage: "" });
            this.props.saveComment(cmts, "DC"); //Deere Comments
            this.setState({ commentVal: "" });
        }
    }

    showMModal = () => {
        this.setState({ showCmtModal: true });
    }

    hideMModal = () => {
        this.setState({ showCmtModal: false });
    }

    render() {
        let size = this.props.commentsCountObj + 2;
        return (
            <div >
                <div className="row">
                    <div className="col-sm-24">
                        {Object.values(this.props.commentsInfoObj).slice(0, 2).map((commentsMap) =>
                            <p>{commentsMap.comment}
                                <br /><span style={{ color: "Grey" }}>{commentsMap.createdBy} on {commentsMap.createdDt}
                                </span>
                            </p>
                        )}
                    </div>
                </div>
                {this.props.commentsCountObj > 0 ?
                    <div className="row">
                        <div className="col-sm-24" style={{ textAlign: 'right' }}>
                            <a href="#" onClick={this.showMModal}>({this.props.commentsCountObj}) More Comments</a>
                        </div>
                    </div>
                    : null
                }
                {this.props.status === 'A' || this.props.status === 'D' || this.props.status === 'N' ? null :
                    <div>
                        <div className="row">
                            <div className="col-sm-24">
                                <TextArea
                                    name={"comment"}
                                    placeholder={"Add Comment"}
                                    rows={"4"}
                                    cols={"500"}
                                    value={this.state.commentVal}
                                    handleChange={this.handleInput}
                                    maxLength="4096"
                                />{" "}<span className="error">{this.state.errorMessage}</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-24" style={{ textAlign: 'right' }}>
                                <Button action={this.handleComment} type="secondary" title="Post Comment" />{" "}
                            </div>
                        </div>
                    </div>
                }
                <Modal size='lg' show={this.state.showCmtModal}>
                    <Modal.Header>
                        <h7 className="modal-title">Comments</h7>
                        <button type="button" className="close" onClick={this.hideMModal}>&times;</button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="border-top border-left border-right">
                            {Object.values(this.props.commentsInfoObj).slice(2, size).map((commentsMap) =>
                                <p className="border-bottom" style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                                    {commentsMap.comment}<br/>
                                    <span style={{ color: "Grey" }}>{commentsMap.createdBy} on {commentsMap.createdDt}</span>
                                </p>
                            )}
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default CommentComponent;